import { Entry } from '../Entry'

export function Entry20241126() {
  return (
    <Entry title="2024 Nov 26 - v3.9.1">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/16163/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
